import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';

import { Cell, Grid } from 'flexomatic';
import { CourseCreatorWrapper, CourseInfoWrapper, SpinnerWrapper } from './styled';

import messages from './messages';

import { Collapse, Down, Expand, Left, Right, Up } from '../../helpers/icon-dictionary';
import updateTreeSelection, {
    buildTopicObject,
    deleteNode,
    filterSpineOnStrandSubStrand,
    findNode,
    findSpineNode,
    getCourseTopics,
    getCurriculumDescriptions,
    getStrandSubstrand,
    handleOnExpandCollapse,
    nodeExpandCollapse,
    onToggle,
    trimStringWithEllipsis,
    updateIndexes,
    updateTopicName
} from '../../helpers/course-creator-utils';

import Button from '../button/index';
import Header from '../header';
import SpineList from '../spine-list';
import CurriculumTree from '../curriculum-tree';
import InputToggle from '../input-toggle';
import SvgIcon from '../svg-icon/svg-icon';
import Container from '../container';
import Alert from '../alert';
import MultiSelectionList from '../multi-selection-list';
import Spinner from '../spinner';
import DropdownList from '../../components/dropdown-list';
import TextInput from '../text-input';
import AddTopic from '../../components/add-topic';
import { modalButtons, publishModalButtons } from './modal-buttons';

import ProductSelector from './product-selector';
import Topics from './topics';
import Footer from './footer';

import { MODAL_TYPES } from './constants';

import {
    COURSE_CREATOR_SUB_ROUTES,
    DROPDOWN_DEFAULT_LOCALE,
    MATHLETICS_PRODUCT_ID,
    RETIRED_COURSE_ID,
    SPELLING_PRODUCT_ID,
    SUPPORTED_LOCALES,
    WRITING_PRODUCT_ID,
    YEAR_GROUPS
} from '../../constants';

class CourseCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            courseName: '',
            isCourseSet: false,
            selectedSpineItems: [],
            topicTree: { childNodes: [] },
            isTreeViewExpanded: false,
            topicId: 1,
            spineIndex: -1,
            girlIndex: -1,
            enableSaveCourse: props.enableSaveCourse,
            enablePublish: props.enablePublish,
            isAlertVisible: true,
            selectedOption: null,
            selectedLocale: '',
            selectedProduct: undefined,
            isTreeExpanded: false,
            selectedTopic: '',
            selectedSpineIds: [],
            displayedSpineNodeList: [],
            isSelectAll: false,
            displayAddTopic: false,
            modalType: '',
            modalData: {
                strand: 'None',
                subStrand: 'None'
            },
            invalidStrands: [],
            invalidStandards: []
        };
        this.parentData = {
            strand: 'None',
            subStrand: 'None'
        };
        this.options = [];
        this.isTreeExpanded = false;
        this.hasColumnExpand = false;

        this.onClickBackButton = this.onClickBackButton.bind(this);
        this.onClickExpandButton = this.onClickExpandButton.bind(this);
        this.updateSpineList = this.updateSpineList.bind(this);
        this.onToggleExpandTree = this.onToggleExpandTree.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onSelectAll = this.onSelectAll.bind(this);
        this.handleAddTopicModal = this.handleAddTopicModal.bind(this);
        this.handleOnUpdateModal = this.handleOnUpdateModal.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    componentWillReceiveProps(nextProps, nextState) {
        const {
            assignedSpineItems = [],
            masterCourse,
            pppCourse,
            isDefaultCourse,
            enableSaveCourse,
            enablePublish,
            isFetched,
            genericCourse,
            match
        } = nextProps;
        const { selectedProduct } = nextState;
        const { topicTree } = this.state;

        if (this.state.enableSaveCourse !== enableSaveCourse) {
            this.setState({ enableSaveCourse });
        }
        if (this.state.enablePublish !== enablePublish) {
            this.setState({ enablePublish });
        }

        if (isFetched) {
            if (this.options.length === 0) {
                this.options = this.getYearGroups(
                    masterCourse,
                    pppCourse,
                    isDefaultCourse
                );
            }

            if (isDefaultCourse) {
                if (topicTree.childNodes.length === 0) {
                    topicTree.childNodes = this.getCourseTopics(
                        pppCourse.topics
                    );
                    this.setState({
                        topicTree,
                        topicId: Math.floor(Math.random() * 10000)
                    });
                }

                if (this.state.selectedOption === null) {
                    const selectedYearGroups =
                        pppCourse.yearGroups &&
                        pppCourse.yearGroups.map(year => ({
                            label: YEAR_GROUPS.find(
                                val => val.id === year.toString()
                            ).value,
                            value: year
                        }));

                    this.setState({ selectedOption: selectedYearGroups });
                }
            }

            if (this.state.selectedOption === null && !isDefaultCourse) {
                const selectedYearGroups =
                    masterCourse.yearGroups &&
                    masterCourse.yearGroups.map(year => ({
                        label: YEAR_GROUPS.find(
                            val => val.id === year.shortName
                        ).value,
                        value: year.yearGroupEnum
                    }));

                this.setState({ selectedOption: selectedYearGroups });
            }

            if (!this.state.isCourseSet) {
                this.enableActionButtons(nextProps);
                this.setState(
                    {
                        courseName: isDefaultCourse ? pppCourse.name : masterCourse.name,
                        courses: masterCourse.spineNodes.map((spine) => {
                            spine.isSelected = false;
                            return spine;
                        }),
                        selectedSpineItems: assignedSpineItems,
                        selectedLocale: pppCourse.locale || DROPDOWN_DEFAULT_LOCALE,
                        isCourseSet: true
                    },
                    () => {
                        this.updateSpineList();
                    }
                );
            }
        }

        const shouldManageProductId = (masterCourse.subjectId || genericCourse.productId) && !selectedProduct;
        if (shouldManageProductId) {
            this.manageProductInitialData({
                actionType: match.params.actionType,
                genericCourse,
                masterCourse
            });
        }
    }

    manageProductInitialData = ({
        actionType,
        genericCourse,
        masterCourse
    }) => {
        const {
            EDIT,
            CLONE,
            COPY
        } = COURSE_CREATOR_SUB_ROUTES;
        const { subjectId } = masterCourse;
        const { productId } = genericCourse;
        let updatedSelectedProduct = null;

        switch (actionType) {
        case CLONE: {
            updatedSelectedProduct = subjectId;
            break;
        }
        case EDIT:
        case COPY: {
            updatedSelectedProduct = productId;
            break;
        }
        default: break;
        }

        this.setState({
            selectedProduct: updatedSelectedProduct
        });
    }

    onSelectAll = () => {
        const { isSelectAll, displayedSpineNodeList } = this.state;
        const { masterCourse } = this.props;
        const isSelected = !isSelectAll;
        let selectedSpineIds = [];

        if (isSelected) {
            displayedSpineNodeList.forEach((spine) => {
                selectedSpineIds.push(spine.id);
            });
        } else {
            selectedSpineIds = [];
        }
        this.setState({
            isSelectAll: isSelected,
            courses: masterCourse.spineNodes.map((spine) => {
                spine.isSelected = isSelected;
                return spine;
            }),
            selectedSpineIds
        });
    };

    onToggleExpandTree(expanded) {
        this.isTreeExpanded = expanded;
        this.hasColumnExpand = false;
        this.setState({
            isTreeExpanded: expanded
        });
    }

    getYearGroups = (masterCourse, pppCourse, isDefaultCourse) => {
        if (isDefaultCourse && pppCourse.yearGroups) {
            return YEAR_GROUPS.filter(
                val => pppCourse.yearGroups.toString().indexOf(val.id) === -1
            ).map(year => ({
                label: year.value,
                value: year.id
            }));
        } else if (masterCourse.yearGroups) {
            const yearGroupIds = masterCourse.yearGroups.map(year =>
                year.yearGroupEnum.toString()
            );
            return YEAR_GROUPS.filter(
                val => yearGroupIds.indexOf(val.id) === -1
            ).map(year => ({
                label: year.value,
                value: year.id
            }));
        }

        return [];
    };

    onClickBackButton() {
        const { EDIT } = COURSE_CREATOR_SUB_ROUTES;
        const {
            isDirty,
            genericCourse,
            match: {
                params: { actionType }
            }
        } = this.props;
        if (
            Number(genericCourse.status) === RETIRED_COURSE_ID &&
            actionType === EDIT
        ) {
            this.props.setCourseCreatorAsClean();
            setTimeout(() => this.props.handleOnback());
            return;
        }

        if (isDirty) {
            this.props.openAlertModal();
        } else {
            this.props.setCourseCreatorAsClean();
            setTimeout(() => this.props.handleOnback());
        }
    }

    onClickExpandButton() {
        this.hasColumnExpand = true;
        this.setState({ isTreeViewExpanded: !this.state.isTreeViewExpanded });
    }

    onDragEnd = (result) => {
        const { destination, source, draggableId } = result;
        let parentId = 0;
        let spineId = 0;
        let subTopic = {};

        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            source.droppableId === 'spineList'
        ) {
            return;
        }

        const topics = this.state.topicTree;

        switch (source.droppableId) {
        case 'topicList':
            this.reorderList(topics.childNodes, result);
            break;
        default:
            if (draggableId.toLowerCase().indexOf('girl') !== -1) {
                parentId = draggableId.split('-')[0];
                spineId = draggableId.split('-')[2];
                const spine = findNode(
                    `${parentId}-${spineId}-spine`,
                    topics.childNodes
                );
                this.reorderList(spine.childNodes, result);
            } else if (draggableId.indexOf('-') !== -1) {
                parentId = draggableId.split('-')[0];
                subTopic = findNode(parentId, topics.childNodes);
                this.reorderList(subTopic.childNodes, result);
            } else {
                parentId = draggableId.substring(
                    draggableId.indexOf('#') + 1
                );
                subTopic = findNode(parentId, topics.childNodes);
                this.reorderList(subTopic.childNodes, result);
            }
            break;
        }
        this.setState({
            topicTree: topics,
            enableSaveCourse: true,
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    reorderList = (items, result) => {
        const { destination, source, draggableId } = result;
        const destinationIndex = this.getIndex(destination.index, items.length);
        const draggableItem = items.find(item => item.id === draggableId);
        const destinationItem = items.find(
            item => item.index === destinationIndex
        );
        destinationItem.index = source.index;
        draggableItem.index = destinationIndex;
        items.splice(source.index, 1);
        items.splice(destinationIndex, 0, draggableItem);
    };

    updateIndexes = (items, type) => {
        const girlIndex = this.state.girlIndex;
        const spineIndex = this.state.spineIndex;
        const response = updateIndexes(items, type, girlIndex, spineIndex);
        this.setState({
            spineIndex: response.spineIdx,
            girlIndex: response.girlIdx
        });
        return response.updatedList;
    };

    getIndex = (destinationIndex, maxLength) => {
        let index = 0;
        if (destinationIndex < 0) {
            return index;
        } else if (destinationIndex > maxLength) {
            index = maxLength;
        } else {
            index = destinationIndex;
        }
        return index;
    };

    updateTopic = () => {
        this.hasColumnExpand = true;
        window.document.querySelector('[name="search"]').value = '';
        const { selectedTopic, selectedSpineIds, topicTree } = this.state;
        const { genericCourse, masterCourse } = this.props;
        const topics = topicTree;
        let topic = null;
        let isSubTopic = false;
        let productId;

        if (selectedTopic.indexOf('#') !== -1) {
            const filteredTopics = topics.childNodes.find(
                item =>
                    item.id ===
                    selectedTopic.split('#')[
                        selectedTopic.split('#').length - 1
                    ]
            );
            topic = findNode(selectedTopic, filteredTopics);
            isSubTopic = true;
        } else {
            topic = topics.childNodes.find(item => item.id === selectedTopic);
        }

        if (genericCourse.productId || masterCourse.subjectId) {
            productId = genericCourse.productId
                ? genericCourse.productId
                : masterCourse.subjectId;
        }

        if (topic) {
            if (
                productId === MATHLETICS_PRODUCT_ID &&
                topic.type.toLowerCase() !== 'step'
            ) {
                this.props.showToast(
                    this.props.intl.formatMessage(messages.spinesUnderSteps),
                    'error'
                );
                return;
            } else if (
                (productId === SPELLING_PRODUCT_ID ||
                    productId === WRITING_PRODUCT_ID) &&
                topic.type.toLowerCase() !== 'descriptor'
            ) {
                this.props.showToast(
                    this.props.intl.formatMessage(
                        messages.spinesUnderDescriptor
                    ),
                    'error'
                );
                return;
            }
            let girlIndex = this.state.girlIndex + 1;
            const spineIdsInTopic = topic.childNodes.map(
                t => t.id.split('-')[1]
            );
            for (const id of selectedSpineIds) {
                // if spine node already exists inside a topic then don't add it again
                if (spineIdsInTopic.indexOf(id) === -1) {
                    const spineNode = this.props.masterCourse.spineNodes.find(
                        item => item.id === id
                    );
                    spineNode.girls = !spineNode.girls ? [] : spineNode.girls;
                    topic.isExpanded = true;
                    topic.isSelected = false;
                    topic.childNodes.push({
                        id: `${topic.id}-${spineNode.id}-spine`,
                        name: `${spineNode.id}: ${spineNode.description}`,
                        index:
                            topic.childNodes.length === 0
                                ? 0
                                : topic.childNodes.length,
                        groupName: isSubTopic
                            ? `subTopic${topic.spineIndex}`
                            : `spine${topic.spineIndex}`,
                        groupType: isSubTopic
                            ? `subTopic${topic.spineIndex}`
                            : `spine${topic.spineIndex}`,
                        girlIndex,
                        isExpanded: false,
                        isSelected: false,
                        childNodes:
                            spineNode.girls.length > 0
                                ? this.updateGirlResources(
                                    spineNode,
                                    topic.id,
                                    spineNode.id,
                                    girlIndex
                                )
                                : [],
                        isEditable: false
                    });
                    girlIndex += 1;
                }
            }

            const courses = this.props.masterCourse.spineNodes.map((spine) => {
                spine.isSelected = false;
                return spine;
            });

            this.updateSpineList(selectedSpineIds);
            this.setState({
                topicTree: topics,
                girlIndex,
                enableSaveCourse: true,
                enablePublish: false,
                selectedTopic: '',
                selectedSpineIds: [],
                isSelectAll: false,
                displayedSpineNodeList: courses
            });
            this.props.setCourseCreatorAsModified();
        }
    };

    updateSpineList = (copiedSpineItems = []) => {
        const selectedSpineItems = [
            ...this.state.selectedSpineItems,
            ...copiedSpineItems
        ];

        const cleanSelectedSpineItems = selectedSpineItems.filter(
            el => el !== null
        );

        const courses = this.props.masterCourse.spineNodes.map((spine) => {
            spine.isSelected = false;
            return spine;
        });

        this.setState({
            selectedSpineItems: cleanSelectedSpineItems,
            courses,
            displayedSpineNodeList: courses,
            isSelectAll: false,
            selectedSpineIds: []
        });
    };

    addSpineItemsToTopic = (spineId) => {
        this.hasColumnExpand = true;

        const { displayedSpineNodeList } = this.state;

        let selectedSpineIds = [...this.state.selectedSpineIds];

        if (selectedSpineIds.indexOf(spineId) === -1) {
            selectedSpineIds.push(spineId);
        } else {
            selectedSpineIds = selectedSpineIds.filter(
                value => value !== spineId
            );
        }

        let isAllSelected = false;
        if (
            selectedSpineIds.length === this.state.displayedSpineNodeList.length
        ) {
            isAllSelected = true;
        }

        let filteredSpineNodes = [];
        if (
            this.state.selectedTopic &&
            this.parentData.strand &&
            this.parentData.strand.toLowerCase() !== 'none'
        ) {
            filteredSpineNodes = filterSpineOnStrandSubStrand(
                this.parentData,
                displayedSpineNodeList
            );
        } else {
            filteredSpineNodes = displayedSpineNodeList;
        }

        const filteredNodes = filteredSpineNodes.map((spine) => {
            if (spine.id === spineId) {
                spine.isSelected = true;
            }
            return spine;
        });

        this.setState({
            selectedSpineIds,
            isSelectAll: isAllSelected,
            displayedSpineNodeList: filteredNodes
        });
    };

    updateGirlResources = (spineNode, topicId, id, girlIndex) =>
        spineNode.girls.map((item, index) => ({
            id: `${topicId}-${item.id}-${id}`,
            name: `${item.id}-${item.teacherTitle}`,
            index,
            groupName: `girl${girlIndex}`,
            groupType: `girl${girlIndex}`,
            childNodes: [],
            isEditable: false,
            isIncluded: true,
            previewUrl: item.previewUrl
        }));

    closeAddTopicModal = (id) => {
        this.setState({
            displayAddTopic: false,
            modalType: '',
            modalData: {
                strand: 'None',
                subStrand: 'None'
            }
        });

        this.parentData = {
            strand: 'None',
            subStrand: 'None',
            type: ''
        };

        if (id) {
            this.selectTopic(id);
        }
    };

    createNewTopic = (topicParams) => {
        const {
            topicName,
            strand,
            subStrand,
            topicType,
            externalKey = '',
            description = '',
            curriculumLevelCode = ''
        } = topicParams;

        const id = this.state.topicId;
        const spineIndex = this.state.spineIndex + 1;
        const topic = {
            id: id.toString(),
            name: topicName,
            index:
                this.state.topicTree.childNodes.length === 0
                    ? 0
                    : this.state.topicTree.childNodes.length,
            groupName: 'topicList',
            groupType: 'topic',
            childNodes: [],
            isEditable: true,
            isExpanded: false,
            isSelected: false,
            type: topicType,
            strand,
            subStrand,
            spineIndex,
            externalKey,
            description,
            curriculumLevelCode
        };
        const topics = this.state.topicTree;
        topics.childNodes.push(topic);
        this.setState({
            topicTree: topics,
            spineIndex,
            enableSaveCourse: true,
            topicId: Math.floor(Math.random() * 10000),
            enablePublish: false
        });

        this.props.setCourseCreatorAsModified();
    };

    handleAddTopicModal = (modalType, id) => {
        const topics = this.state.topicTree;
        let modalData = {};
        if (modalType === MODAL_TYPES.newTopic) {
            this.parentData = {
                strand: 'None',
                subStrand: 'None',
                type: ''
            };
            modalData = {
                strand: 'None',
                subStrand: 'None'
            };
        } else {
            modalData = modalType === MODAL_TYPES.edit ? getStrandSubstrand(id, topics) : getStrandSubstrand(null, topics);
        }

        this.setState({
            displayAddTopic: true,
            modalType,
            selectedTopic: id,
            modalData
        });
    };

    handleOnUpdateModal = (
        updatedObject
    ) => {
        const { modalType } = this.state;
        const {
            curriculumLevelCode,
            description,
            externalKey,
            strand,
            subStrand,
            topicId,
            topicName,
            topicType
        } = updatedObject;

        switch (modalType) {
        case MODAL_TYPES.edit:
            this.updateTopicName({
                id: topicId,
                name: topicName,
                strand,
                subStrand,
                externalKey,
                description,
                curriculumLevelCode
            });
            break;

        case MODAL_TYPES.newTopic:
            this.createNewTopic({
                topicName,
                strand,
                subStrand,
                topicType,
                externalKey,
                description,
                curriculumLevelCode
            });
            break;

        case MODAL_TYPES.newSubTopic:
            this.createSubTopics({
                curriculumLevelCode,
                description,
                externalKey,
                strand,
                subStrand,
                subTopicName: topicName,
                topicType
            });
            break;

        default:
            break;
        }
    };

    createSubTopics = (subTopicsParams) => {
        const {
            curriculumLevelCode = '',
            description = '',
            externalKey = '',
            strand,
            subStrand,
            subTopicName,
            topicType
        } = subTopicsParams;

        const topicId = this.state.selectedTopic;
        const topics = this.state.topicTree;
        let topic = {};
        if (topicId.indexOf('#') === -1) {
            topic = topics.childNodes.find(item => item.id === topicId);
        } else {
            const filteredTopics = topics.childNodes.find(
                item =>
                    item.id ===
                    topicId.split('#')[topicId.split('#').length - 1]
            );
            topic = findNode(topicId, filteredTopics);
        }
        const spineIndex = this.state.spineIndex + 1;
        topic.isSelected = false;
        topic.isExpanded = true;
        topic.childNodes.push({
            id: `${this.state.topicId.toString()}#${topicId}`,
            name: subTopicName,
            index: topic.childNodes.length === 0 ? 0 : topic.childNodes.length,
            groupName: `spine${topic.spineIndex}`,
            groupType: `spine${topic.spineIndex}`,
            childNodes: [],
            isEditable: true,
            isExpanded: false,
            isSelected: false,
            type: topicType,
            externalKey,
            strand,
            subStrand,
            spineIndex,
            description,
            curriculumLevelCode
        });
        this.setState({
            topicTree: topics,
            spineIndex,
            selectedTopic: '',
            enableSaveCourse: true,
            topicId: Math.floor(Math.random() * 10000),
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    updateTopicName = (response) => {
        this.setState({
            topicTree: updateTopicName(response, this.state.topicTree),
            enableSaveCourse: true,
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    updateTopicExpand = (id, status) => {
        this.hasColumnExpand = true;
        this.setState({
            topicTree: nodeExpandCollapse(id, status, this.state.topicTree)
        });
    };

    onDelete = (id) => {
        const topics = this.state.topicTree;
        const spineIds = [];

        if (id.indexOf('spine') !== -1) {
            deleteNode(id, topics);
            const spineId = this.state.selectedSpineItems.indexOf(
                id.split('-')[1]
            );
            if (spineId !== -1) {
                const selectedSpineItems = [...this.state.selectedSpineItems];
                delete selectedSpineItems[spineId];
                this.setState({ selectedSpineItems }, () => {
                    this.updateSpineList();
                });
            }
        } else {
            const deletedTopic = deleteNode(id, topics);
            if (deletedTopic) {
                findSpineNode(deletedTopic, spineIds);
                const newSpineItems = [];
                this.state.selectedSpineItems.filter((spineItem) => {
                    if (spineIds.indexOf(spineItem) === -1) {
                        newSpineItems.push(spineItem);
                    }
                    return spineItem.indexOf(spineIds) === -1;
                });

                this.setState({ selectedSpineItems: newSpineItems }, () => {
                    this.updateSpineList();
                });
            }
        }
        this.setState({
            topicTree: updateIndexes(id, topics),
            enableSaveCourse: true,
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    onToggle = (id, status) => {
        this.setState({
            topicTree: onToggle(id, status, this.state.topicTree),
            enableSaveCourse: true,
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    updateCourseName = (response) => {
        this.hasColumnExpand = true;
        this.setState({
            courseName: response.name,
            enableSaveCourse: true,
            enablePublish: false
        });
        this.props.setCourseCreatorAsModified();
    };

    enableActionButtons = (props) => {
        const { isDefaultCourse, pppCourse, match } = props;
        const copyMode = match.url.indexOf('copy') !== -1;
        let enableSaveCourse = false;
        let enablePublish = false;
        if (isDefaultCourse) {
            if (copyMode) {
                enableSaveCourse = true;
            } else {
                switch (pppCourse.status) {
                case '0':
                    enablePublish = true;
                    break;
                default:
                    break;
                }
            }
        }

        this.setState({ enableSaveCourse, enablePublish });
    };

    getCourseTopics = (topics) => {
        const girlIndex = this.state.girlIndex + 1;
        const spineIndex = this.state.spineIndex + 1;
        const response = getCourseTopics(topics, girlIndex, spineIndex);
        this.setState({
            spineIndex: response.spineIdx,
            girlIndex: response.girlIdx,
            topicId: response.topicId + 1
        });
        return response.childNodes;
    };

    handleChange = (selectedOption) => {
        this.hasColumnExpand = true;
        this.props.setCourseCreatorAsModified();
        const yearGroupIds = selectedOption.map(option =>
            option.value.toString()
        );
        this.options = YEAR_GROUPS.filter(
            val => yearGroupIds.indexOf(val.id) === -1
        ).map(year => ({
            label: year.value,
            value: year.id
        }));
        this.setState({
            selectedOption,
            enableSaveCourse: true,
            enablePublish: false
        });
    };

    handleOnExpandCollapse = (status) => {
        this.hasColumnExpand = true;
        this.setState({
            topicTree: handleOnExpandCollapse(status, this.state.topicTree)
        });
    };

    selectTopic = (id) => {
        this.hasColumnExpand = true;

        const {
            topicTree,
            selectedTopic,
            courses,
            displayedSpineNodeList
        } = this.state;

        this.parentData = getStrandSubstrand(id, topicTree);

        const topicId = updateTreeSelection(id, topicTree, selectedTopic);

        let filteredSpineNodes = [];
        if (
            topicId &&
            this.parentData.strand &&
            this.parentData.strand.toLowerCase() !== 'none'
        ) {
            filteredSpineNodes = filterSpineOnStrandSubStrand(
                this.parentData,
                displayedSpineNodeList
            );
        } else {
            const searchTerm = this.searchQuery.state.value.toLowerCase();
            if (searchTerm) {
                filteredSpineNodes = courses.filter((el) => {
                    const hasResult =
                        el.description.toLowerCase().indexOf(searchTerm) !==
                        -1 ||
                        el.id.toLowerCase().indexOf(searchTerm) !== -1;
                    return hasResult;
                });
            } else {
                filteredSpineNodes = courses;
            }
        }
        this.setState({
            topicTree,
            selectedTopic: topicId,
            displayedSpineNodeList: filteredSpineNodes
        });
    };

    closeAlertModal = () => {
        this.props.closeAlertModal();
        this.setState({ enableSaveCourse: true, enablePublish: false });
    };

    disableCreateSubTopic = () => {
        let disable = true;
        const { selectedTopic } = this.state;
        if (selectedTopic !== '' && selectedTopic.indexOf('#') === -1) {
            disable = false;
        }
        return disable;
    };

    searchHandler = () => {
        const searchTerm = this.searchQuery.state.value.toLowerCase();
        let displayedSpineNodeList = [];
        let filteredSpineNodes = [];
        const { topicTree, selectedTopic, courses, isSelectAll } = this.state;
        const topic = getStrandSubstrand(selectedTopic, topicTree);

        if (topic) {
            filteredSpineNodes = filterSpineOnStrandSubStrand(topic, courses);
        }
        if (selectedTopic) {
            displayedSpineNodeList = filteredSpineNodes;
        } else {
            displayedSpineNodeList = courses;
        }

        if (searchTerm) {
            displayedSpineNodeList = displayedSpineNodeList.filter((el) => {
                const hasResult =
                    el.description.toLowerCase().indexOf(searchTerm) !== -1 ||
                    el.id.toLowerCase().indexOf(searchTerm) !== -1;
                return hasResult;
            });
        }

        this.setState({ displayedSpineNodeList });
        if (isSelectAll) {
            this.setState({
                isSelectAll: false,
                courses: this.props.masterCourse.spineNodes.map((spine) => {
                    spine.isSelected = false;
                    return spine;
                }),
                selectedSpineIds: []
            });
        }
    };

    getCurriculumLink = () => {
        if (this.state.modalData.curriculumLevelCode) {
            return trimStringWithEllipsis(this.state.modalData.description);
        }
        return '';
    };

    onProductSelectorChangeHandler = (key, value) => {
        this.props.setCourseCreatorAsModified();
        this.setState({
            selectedProduct: value
        });
    }

    /**
     * SAVE AS DRAFT
     */
    getSaveCourseRequestId = () => {
        const {
            EDIT,
            CLONE,
            COPY
        } = COURSE_CREATOR_SUB_ROUTES;
        const {
            pppCourse,
            courseId,
            match: {
                params: { actionType }
            }
        } = this.props;
        switch (actionType) {
        case EDIT: return pppCourse.id;
        case CLONE:
        case COPY: return courseId !== 0 ? courseId : 0;
        default: return null;
        }
    }

    createCurriculumLinkArray = () => {
        const { masterCourse } = this.props;
        const returnedCurriculumLinkIds = [];

        function iterateNodes(nodes) {
            nodes.forEach((nodeItem) => {
                const isSpineItem = 'girls' in nodeItem;

                if (nodeItem.id && nodeItem.id !== '' && !isSpineItem) {
                    if (returnedCurriculumLinkIds.indexOf(nodeItem.id) === -1) returnedCurriculumLinkIds.push(nodeItem.id);
                }

                if (nodeItem.children && nodeItem.children.length > 0) {
                    iterateNodes(nodeItem.children);
                }
            });
        }

        iterateNodes(masterCourse.tree.nodes);
        return returnedCurriculumLinkIds;
    }

    createSpineNodesArray = () => {
        const { masterCourse } = this.props;
        const returnedSpineIds = [];

        masterCourse.spineNodes.forEach((spineItem) => {
            if (spineItem.id && spineItem.id !== '') {
                returnedSpineIds.push(spineItem.id);
            }
        });

        return returnedSpineIds;
    }

    onValidRequest = () => {
        if (this.state.invalidStrands.length > 0) {
            this.setState({
                invalidStrands: []
            });
        }
        if (this.state.invalidStandards.length > 0) {
            this.setState({
                invalidStandards: []
            });
        }

        return true;
    }

    onInvalidRequest = ({ invalidStrands, invalidStandards, hasSpineNode }) => {
        if (invalidStrands.length > 0) {
            this.setState({
                invalidStrands
            });
            this.props.showToast(
                this.props.intl.formatMessage(
                    messages.emptySteps
                ),
                'error'
            );
        } else {
            this.setState({
                invalidStrands: []
            });
        }

        if (invalidStandards.length > 0) {
            this.setState({
                invalidStandards
            });
            this.props.showToast(
                this.props.intl.formatMessage(
                    messages.emptyCurriculumLink
                ),
                'error'
            );
        } else {
            this.setState({
                invalidStandards: []
            });
        }

        if (!hasSpineNode) {
            this.props.showToast(
                this.props.intl.formatMessage(
                    messages.noSpineNode
                ),
                'error'
            );
        }

        return false;
    }

    validateSaveCourseRequest = () => {
        const { topicTree } = this.state;
        const invalidSpineNodes = [];
        const invalidStrands = [];
        const invalidStandards = [];

        const curriculumLinkArray = this.createCurriculumLinkArray();
        const spineNodesArray = this.createSpineNodesArray();

        let hasSpineNode = false;

        topicTree.childNodes.forEach((topic) => {
            if (topic.type.toLowerCase() === 'strand') {
                const strandId = topic.id;

                if (!curriculumLinkArray.includes(topic.curriculumLevelCode)) {
                    if (invalidStrands.indexOf(strandId) === -1) invalidStrands.push(strandId);
                }

                if (topic.childNodes.length > 0) {
                    topic.childNodes.forEach((standard) => {
                        const standardId = standard.id;

                        if (!curriculumLinkArray.includes(standard.curriculumLevelCode)) {
                            if (invalidStandards.indexOf(standardId) === -1) invalidStandards.push(standardId);
                        }

                        if (standard.childNodes.length > 0) {
                            standard.childNodes.forEach((learningJourney) => {
                                if (learningJourney.childNodes.length > 0) {
                                    learningJourney.childNodes.forEach((step) => {
                                        if (step.childNodes.length > 0) {
                                            step.childNodes.forEach((spineNode) => {
                                                hasSpineNode = true;
                                                const spineNodeId = spineNode.id.split('-')[1];

                                                if (!spineNodesArray.includes(spineNodeId)) {
                                                    if (invalidSpineNodes.indexOf(spineNode.id) === -1) invalidSpineNodes.push(spineNode.id);
                                                    if (invalidStandards.indexOf(standardId) === -1) invalidStandards.push(standardId);
                                                }
                                            });
                                        } else if (invalidStandards.indexOf(standardId) === -1) {
                                            invalidStandards.push(standardId);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        });

        const hasValidData =
            invalidStrands.length === 0 &&
            invalidStandards.length === 0 &&
            hasSpineNode;

        if (hasValidData) {
            return this.onValidRequest();
        }

        return this.onInvalidRequest({
            invalidStrands,
            invalidStandards,
            hasSpineNode
        });
    }

    createSaveCourseRequest = () => {
        const {
            masterCourse: {
                id: masterCourseId,
                version: masterCourseVersion,
                countryCode
            },
            pppCourse: {
                state
            }
        } = this.props;
        const {
            topicTree,
            courseName,
            selectedLocale,
            selectedProduct,
            selectedOption
        } = this.state;

        if (this.validateSaveCourseRequest()) {
            return {
                id: this.getSaveCourseRequestId(),
                masterCourseId,
                productId: selectedProduct,
                masterCourseVersion,
                name: courseName,
                state,
                countryCode,
                locale: selectedLocale,
                yearGroups: selectedOption.map(item => parseInt(item.value, 10)),
                topics: topicTree.childNodes.length > 0 ? buildTopicObject(topicTree) : []
            };
        }

        return false;
    }

    saveCourse = () => {
        const request = this.createSaveCourseRequest();

        if (request) {
            this.props.saveCourse(request);
        }
    };

    /**
     * PUBLISH COURSE
     */
    getPublishCourseId = () => {
        const {
            CLONE,
            COPY,
            EDIT
        } = COURSE_CREATOR_SUB_ROUTES;
        const {
            courseId,
            match: {
                params: { actionType }
            },
            pppCourse
        } = this.props;

        switch (actionType) {
        case CLONE: return courseId;
        case COPY:
        case EDIT: return courseId > 0 ? courseId : pppCourse.id;
        default: return null;
        }
    }

    onPublishCourse = () => {
        const { selectedProduct } = this.state;
        const selectedCourseId = this.getPublishCourseId();

        this.props.publishCourse(selectedCourseId, selectedProduct);
        this.props.showPublishModal(false);
    }

    /**
     * RENDER
     */
    render() {
        const { EDIT } = COURSE_CREATOR_SUB_ROUTES;
        const {
            intl,
            masterCourse,
            pppCourse,
            standardFilters,
            curriculumLevelDescriptions,
            isDefaultCourse,
            genericCourse,
            showPublishModal,
            isFetched,
            match: {
                params: { actionType }
            }
        } = this.props;
        const {
            isTreeViewExpanded,
            topicName,
            selectedProduct,
            enablePublish,
            enableSaveCourse,
            topicTree,
            invalidStrands,
            invalidStandards
        } = this.state;

        if (!isFetched) {
            return (
                <SpinnerWrapper>
                    <Spinner />
                </SpinnerWrapper>
            );
        }

        return (
            <CourseCreatorWrapper>
                <Header title={intl.formatMessage(messages.header)} />
                <Container zeroPadding>
                    <Grid style={{ marginTop: 0 }}>
                        <Cell>
                            <div className="courseName">
                                <InputToggle
                                    getInputValue={this.updateCourseName}
                                    name={this.state.courseName}
                                    placeHolder="Course Name"
                                />
                            </div>
                        </Cell>
                        <Cell width={[0.1]}>
                            <Grid align="center" style={{ marginTop: 0 }}>
                                <Cell>
                                    {isDefaultCourse && genericCourse.version
                                        ? `Version: ${genericCourse.id}v${genericCourse.version}`
                                        : ''}
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell width={[1, 0.35, 0.25]}>
                            <Grid align="center">
                                <Cell width={[0.15]}>Locale:</Cell>
                                <Cell width={[0.35]}>
                                    <DropdownList
                                        name="locale"
                                        onChange={this.onProductSelectorChangeHandler}
                                        options={SUPPORTED_LOCALES}
                                        value={
                                            this.state.selectedLocale ||
                                            pppCourse.locale ||
                                            DROPDOWN_DEFAULT_LOCALE
                                        }
                                    />
                                </Cell>
                                <ProductSelector
                                    isDisabled={isDefaultCourse}
                                    onChangeHandler={this.onProductSelectorChangeHandler}
                                    selectedProduct={selectedProduct}
                                />
                            </Grid>
                        </Cell>
                        <Cell width={1}>
                            <Grid>
                                <Cell width={[0.3]}>
                                    <CourseInfoWrapper>
                                        <strong>
                                            {intl.formatMessage(
                                                messages.country
                                            )}
                                            :
                                        </strong>{' '}
                                        {masterCourse.countryCode}
                                    </CourseInfoWrapper>
                                    <CourseInfoWrapper>
                                        <strong>
                                            {intl.formatMessage(messages.state)}
                                            :
                                        </strong>{' '}
                                        {masterCourse.state}
                                    </CourseInfoWrapper>
                                </Cell>
                                <Cell width={[0.5, 0.35, 0.45]}>
                                    <CourseInfoWrapper>
                                        <strong>
                                            {intl.formatMessage(
                                                messages.curriculum
                                            )}
                                            :
                                        </strong>{' '}
                                        {masterCourse.name}
                                        {isDefaultCourse && masterCourse.version
                                            ? ` v${masterCourse.version}`
                                            : ''}
                                    </CourseInfoWrapper>
                                </Cell>
                                <Cell width={[0.25, 0.35, 0.23]}>
                                    <Grid align="center">
                                        <Cell width={[0.25]}>
                                            <strong>
                                                {intl.formatMessage(
                                                    messages.yearLevel
                                                )}
                                                :
                                            </strong>
                                        </Cell>
                                        <Cell>
                                            <MultiSelectionList
                                                handleChange={this.handleChange}
                                                options={this.options}
                                                value={
                                                    this.state.selectedOption
                                                }
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                            </Grid>
                        </Cell>
                    </Grid>
                    <div className="coursePanel">
                        <div
                            className={
                                isTreeViewExpanded
                                    ? `${'fullWidth'} ${'header'}`
                                    : 'header'
                            }
                        >
                            <div
                                className={
                                    isTreeViewExpanded
                                        ? `${'fullWidth'} ${'treeColumn'}`
                                        : 'treeColumn'
                                }
                            >
                                <div className="curriculumHeaderName">
                                    {intl.formatMessage(messages.curriculum)}
                                </div>
                                <div
                                    className="expand"
                                    onClick={() =>
                                        this.onToggleExpandTree(false)
                                    }
                                    role="button"
                                    tabIndex="-1"
                                    title={intl.formatMessage(
                                        messages.collapse
                                    )}
                                >
                                    <SvgIcon icon={Up} />
                                </div>
                                <div
                                    className="expand"
                                    onClick={() =>
                                        this.onToggleExpandTree(true)
                                    }
                                    role="button"
                                    tabIndex="-1"
                                    title={intl.formatMessage(messages.expand)}
                                >
                                    <SvgIcon icon={Down} />
                                </div>
                                <div
                                    className="icon"
                                    onClick={this.onClickExpandButton}
                                    role="button"
                                    tabIndex="-1"
                                >
                                    {isTreeViewExpanded && (
                                        <SvgIcon icon={Left} />
                                    )}
                                    {!isTreeViewExpanded && (
                                        <SvgIcon icon={Right} />
                                    )}
                                </div>
                            </div>
                            <div
                                className={
                                    isTreeViewExpanded
                                        ? 'hideRow'
                                        : 'topicColumn'
                                }
                            >
                                <div className="topicHeaderAdd">
                                    <div className="checkbox">
                                        <input
                                            checked={this.state.isSelectAll}
                                            className="name"
                                            id="selectAll"
                                            onChange={this.onSelectAll}
                                            type="checkbox"
                                        />
                                        <label
                                            className="chklabel"
                                            htmlFor="selectAll"
                                        />
                                    </div>
                                    <div className="spineNode">
                                        {intl.formatMessage(messages.spine)}
                                    </div>
                                    <TextInput
                                        handleOnChange={this.searchHandler}
                                        id="search"
                                        name="search"
                                        placeholder="search"
                                        ref={(input) => {
                                            this.searchQuery = input;
                                        }}
                                    />
                                    <div className="topicHeaderNewTopic">
                                        <Button
                                            className="newTopicButton"
                                            disabled={
                                                this.state.selectedSpineIds
                                                    .length === 0 ||
                                                this.state.selectedTopic === ''
                                            }
                                            handleOnClick={this.updateTopic}
                                            label={intl.formatMessage(
                                                messages.add
                                            )}
                                            primary
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    isTreeViewExpanded
                                        ? 'hideRow'
                                        : 'topicColumn'
                                }
                            >
                                <div className="topicHeader">
                                    <div className="topicHeaderName">
                                        {intl.formatMessage(messages.topics)}
                                    </div>
                                    <div className="topicHeaderIcons">
                                        <div
                                            className="iconStyle"
                                            onClick={() =>
                                                this.handleOnExpandCollapse(
                                                    true
                                                )
                                            }
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <SvgIcon icon={Expand} />
                                        </div>
                                        <div
                                            className="iconStyle"
                                            onClick={() =>
                                                this.handleOnExpandCollapse(
                                                    false
                                                )
                                            }
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <SvgIcon icon={Collapse} />
                                        </div>
                                    </div>
                                    <div className="topicHeaderNewTopic">
                                        <div>
                                            <Button
                                                className="newTopicButton"
                                                handleOnClick={() =>
                                                    this.handleAddTopicModal(
                                                        MODAL_TYPES.newTopic,
                                                        this.state.selectedTopic
                                                    )
                                                }
                                                label={intl.formatMessage(
                                                    messages.newTopic
                                                )}
                                                primary
                                            />
                                        </div>
                                        <div>
                                            <Button
                                                className="newTopicButton"
                                                disabled={
                                                    !this.state.selectedTopic ||
                                                    this.parentData.type.toLowerCase() ===
                                                    'step'
                                                }
                                                handleOnClick={() =>
                                                    this.handleAddTopicModal(
                                                        MODAL_TYPES.newSubTopic,
                                                        this.state.selectedTopic
                                                    )
                                                }
                                                label={intl.formatMessage(
                                                    messages.subTopic
                                                )}
                                                primary
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="panelRow">
                            <div
                                className={
                                    isTreeViewExpanded
                                        ? 'fullWidth treeRows'
                                        : 'treeRows'
                                }
                            >
                                <CurriculumTree
                                    expandTree={this.isTreeExpanded}
                                    hasColumnExpand={this.hasColumnExpand}
                                    key={masterCourse.id}
                                    {...this.props}
                                />
                            </div>
                            <div
                                className={
                                    isTreeViewExpanded ? 'hideRow' : 'spineRows'
                                }
                            >
                                <SpineList
                                    onChange={this.addSpineItemsToTopic}
                                    spineNodes={
                                        this.state.displayedSpineNodeList
                                    }
                                />
                            </div>
                            <Topics
                                handleAddTopicModal={this.handleAddTopicModal}
                                invalidStandards={invalidStandards}
                                invalidStrands={invalidStrands}
                                isExpanded={isTreeViewExpanded}
                                onDelete={this.onDelete}
                                onDragEnd={this.onDragEnd}
                                onToggle={this.onToggle}
                                selectTopic={this.selectTopic}
                                topicTree={topicTree}
                                updateTopicExpand={this.updateTopicExpand}
                                updateTopicName={this.updateTopicName}
                            />
                        </div>
                    </div>
                </Container>
                <Footer
                    enablePublish={enablePublish}
                    enableSaveCourse={enableSaveCourse}
                    genericCourse={genericCourse}
                    isEditing={actionType === EDIT}
                    onClickBackButton={this.onClickBackButton}
                    saveCourse={this.saveCourse}
                    showPublishModal={showPublishModal}
                />
                <AddTopic
                    curriculumLevelDescriptions={getCurriculumDescriptions(
                        curriculumLevelDescriptions
                    )}
                    defaultDescription={this.getCurriculumLink()}
                    handleOnUpdateModal={this.handleOnUpdateModal}
                    id={this.state.selectedTopic}
                    intl={intl}
                    modalData={this.state.modalData}
                    modalType={this.state.modalType}
                    name={topicName}
                    onClose={this.closeAddTopicModal}
                    onDelete={this.onDelete}
                    parentData={this.parentData}
                    selectedProduct={selectedProduct}
                    show={this.state.displayAddTopic}
                    standardFilters={standardFilters}
                    strand={this.state.strand}
                    subStrand={this.state.subStrand}
                    topicTypes={this.props.topicTypes}
                />
                <Alert
                    buttons={modalButtons(
                        this.closeAlertModal,
                        this.props.setCourseCreatorAsClean,
                        this.props.handleOnback
                    )}
                    isActive={this.props.isAlertVisible}
                    subTitle="You have unsaved changes and will lose these changes"
                    title="Unsaved Changes"
                    warning
                />
                <Alert
                    buttons={publishModalButtons(
                        showPublishModal,
                        this.onPublishCourse
                    )}
                    isActive={this.props.isPublishModalVisible}
                    subTitle="Please confirm that you wish to create a new published version of this course and you understand the impact on teachers using this course"
                    title="Are you sure?"
                    warning
                />
            </CourseCreatorWrapper>
        );
    }
}

CourseCreator.defaultProps = {
    masterCourse: {
        yearGroups: []
    },
    pppCourse: {},
    isDefaultCourse: false,
    genericCourse: {}
};

CourseCreator.propTypes = {
    intl: intlShape.isRequired,
    courseId: PropTypes.number,
    masterCourse: PropTypes.object.isRequired,
    genericCourse: PropTypes.object,
    pppCourse: PropTypes.object,
    handleOnback: PropTypes.func,
    saveCourse: PropTypes.func,
    publishCourse: PropTypes.func,
    enableSaveCourse: PropTypes.bool,
    enablePublish: PropTypes.bool,
    assignedSpineItems: PropTypes.array,
    isDefaultCourse: PropTypes.bool,
    copyMode: PropTypes.bool,
    closeAlertModal: PropTypes.func,
    openAlertModal: PropTypes.func,
    setCourseCreatorAsModified: PropTypes.func,
    setCourseCreatorAsClean: PropTypes.func,
    isAlertVisible: PropTypes.bool,
    isDirty: PropTypes.bool,
    match: PropTypes.object,
    isFetched: PropTypes.bool,
    standardFilters: PropTypes.object,
    curriculumLevelDescriptions: PropTypes.array,
    topicTypes: PropTypes.array,
    showPublishModal: PropTypes.func,
    isPublishModalVisible: PropTypes.bool,
    showToast: PropTypes.func.isRequired
};

export default injectIntl(CourseCreator);



// WEBPACK FOOTER //
// ./app/components/course-creator/index.js